import PageTitle from '../components/PageTitle';

export default function Restrictions() {
    return (
        <>
            <PageTitle title="Обмеження" />
            тут поки що нічого немає.
        </>
    );
}
